import React from "react";
import { Box, Typography, TextareaAutosize, Button } from "@mui/material";

function Edit() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="end"
      width="100%"
      minHeight="100vh"
    >
      <Typography variant="h1" textAlign="right">
        تغییر اطلاعات شخصی
      </Typography>
      <Box width="100%" mt={10} display="flex" justifyContent="center">
        <Box
          width="418px"
          bgcolor="#FAFAFA"
          display="flex"
          flexDirection="column"
          alignItems="end"
          borderRadius={3}
          p={3}
        >
          <Typography variant="h1" mb={4}>
            لطفا دلیل خود را شرح دهید
          </Typography>
          <TextareaAutosize
            style={{
              width: "100%",
              borderStyle: "none",
              backgroundColor: "#fff",
              textAlign: "right",
            }}
            minRows={6}
            placeholder="....اینجا بنویسید"
          />
          <Box
            display="flex"
            justifyContent="center"
            flexDirection={{ xs: "column-reverse", sm: "row", md: "row" }}
            alignItems="center"
            width="100%"
            mt={4}
          >
            <Button variant="m2">انصراف</Button>
            <Button
              variant="m1"
              sx={{
                width: "165px",
                ml: { xs: 0, md: 2 },
                my: { xs: 1, md: 0 },
              }}
            >
              ارسال
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Edit;
